import { gql } from '@apollo/client'

export const SHOP_DRIVER_TIP_VARIANT_FRAGMENT = gql`
  fragment ShopDriverTipVariant on ShopDriverTipVariant {
    amount
    amountFormatted
    percentage
  }
`
